export interface AuthErrorCodes {
  [code: string]: {
    de: string;
    en: string;
    nl: string;
  };
}

export const authErrorCodes: AuthErrorCodes = {
  tenant_not_allowed: {
    de: "Ihre Organisation ist nicht mit dem System verbunden",
    en: "Your organization is not linked with the system",
    nl: "Uw organisatie is niet gekoppeld aan het systeem",
  },
  tenant_not_active: {
    de: "Ihre Organisation ist nicht aktiv",
    en: "Your organization is not active",
    nl: "Uw organisatie is niet actief",
  },
  admin_consent_failed: {
    de: "Die Einwilligung zur Berechtigung ist fehlgeschlagen",
    en: "The permission consent failed",
    nl: "De toestemming is mislukt",
  },
  admin_consent_not_granted: {
    de: "Die Einwilligung wurde abgelehnt",
    en: "The permission consent was declined",
    nl: "De toestemming is geweigerd",
  },
  user_not_assigned: {
    de: "Ihr Benutzer ist dieser App keine Rolle zugewiesen",
    en: "Your user is not assigned to a role within this app",
    nl: "Uw gebruiker is niet toegewezen aan een rol binnen deze app",
  },
  user_not_authorized: {
    de: "Ihr Benutzer ist nicht berechtigt, auf diese App zuzugreifen",
    en: "Your user is not authorized to access this app",
    nl: "Uw gebruiker heeft geen toestemming om toegang te krijgen tot deze app",
  },
  token_generation_failed: {
    de: "Die Erstellung der Anmeldedaten ist fehlgeschlagen",
    en: "The credential generation failed",
    nl: "Het genereren van de inloggegevens is mislukt",
  },
  license_not_available: {
    de: "Die maximale Anzahl an Nutzern wurde erreicht. Bitte wenden Sie sich an Ihre interne Administration, um zusätzlichen Zugang zu beantragen.",
    en: "The maximum number of users has been reached. Please contact your internal administrator to request additional access.",
    nl: "Het maximale aantal gebruikers is bereikt. Neem contact op met uw interne beheerder om extra toegang aan te vragen.",
  },
};

export function getAuthErrorCode(code: string, language: string): string {
  let errorCode = authErrorCodes[code] ?? authErrorCodes.user_not_authorized;

  switch (language) {
    case "en":
      return errorCode.en;
    case "nl":
      return errorCode.nl;
    default:
      return errorCode.de;
  }
}
